export const AUTH_CALLBACK_PATH = "/auth/callback";

export const getSsoCallbackUrl = (): string =>
  `${window.location.origin}${AUTH_CALLBACK_PATH}`;
